import React, { useEffect } from 'react';
import CustomTab from "../../components/ui/CustomTab";
import { useDispatch } from 'react-redux';
import { pushRoute, setSaveDashboardFormState } from '../../store/globalSlice';

const tabs = [
	{
		label: "User Administration",
		to: "user_admin",
		value: "/admin/user_admin",
	},
	{
		label: "Group Scenario Activity",
		to: "Group_Scenario_Activity",
		value: "/admin/Group_Scenario_Activity",
	},
  {
		label: "Approval Level",
		to: "approval",
		value: "/admin/approval",
	},
  	// {
	// 	label: "SKU Replacement",
	// 	to: "SKU_Replacement",
	// 	value: "/admin/SKU_Replacement",
	// },
//   {
// 		label: "UOM",
// 		to: "UOM",
// 		value: "/admin/UOM",
// 	},
];

const Admin = () => {
  const dispatch = useDispatch();
    useEffect(() => {
      dispatch(setSaveDashboardFormState(false));
      dispatch(pushRoute("admin"));
    }, []);
  return (
    <CustomTab tabs={tabs} />
  )
}

export default Admin